import { ActionType, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { ProductReviewsResponse } from './types';

export const fetchProductReviewsActions = createAsyncAction(
    '@PRODUCT_REVIEWS/FETCH_START',
    '@PRODUCT_REVIEWS/FETCH_SUCCESS',
    '@PRODUCT_REVIEWS/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<ProductReviewsResponse>, DefaultErrorPayload>();

type GetReviewType = {
    page?: number;
    sku?: string;
    urlKey?: string;
};

export const fetchProductReviewsIfNeeded = ({
    page = 1,
    sku = '',
    urlKey = '',
}: GetReviewType): DataFetchingThunkAction => async (dispatch, getState, { apiService, logger }) => {
    const perPage = 10;
    const identifier = urlKey || `productratings/${sku}:page=${page}`;

    if (identifier === getState().productdetails.reviews.identifier) {
        return;
    }

    dispatch(fetchProductReviewsActions.request({ identifier }));
    try {
        let reviews;
        if (urlKey) {
            reviews = await apiService.shopApi.getProductReviewsByUrlkey(urlKey, { perPage, page });
        } else {
            reviews = await apiService.shopApi.getProductReviews(sku, { perPage, page });
        }
        dispatch(
            fetchProductReviewsActions.success({ data: reviews, identifier, reducerPayloadOptions: { sku, urlKey } })
        );
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchProductReviewsIfNeeded');
        dispatch(fetchProductReviewsActions.failure({ error: err, identifier }));
    }
};

export const ProductReviewsActions = [
    fetchProductReviewsActions.failure,
    fetchProductReviewsActions.request,
    fetchProductReviewsActions.success,
];

export type ProductReviewsActionsType =
    | ActionType<typeof fetchProductReviewsActions.failure>
    | ActionType<typeof fetchProductReviewsActions.request>
    | ActionType<typeof fetchProductReviewsActions.success>;
